import {setMethodsFromAttrs} from '../../modules/util';

const _attrs = {
  fitLine: false
}

const fitLinableMixin = Base => {
  let FitLineable = class extends Base {
    constructor(appendedAttrs) {
      for (let k in _attrs) {
        appendedAttrs[k] = _attrs[k];
      }
      super(appendedAttrs);
    }
  }
  setMethodsFromAttrs(FitLineable, _attrs);
  return FitLineable;
}

export default fitLinableMixin;


// WEBPACK FOOTER //
// ./layouts/fitLineable/index.js